import React, { forwardRef, HTMLAttributes, ReactNode, Ref } from "react";

import classnames from "classnames";

import { StyledMenuHeader } from "./Styles";
import { Typography } from "../Typography/Typography";

interface IMenuHeader {
  className?: string;
  title?: string;
  leftElement?: ReactNode;
  rightElement?: ReactNode;
}

export const MenuHeader = forwardRef(
  (
    {
      title,
      className,
      leftElement,
      rightElement,
      ...props
    }: IMenuHeader & HTMLAttributes<HTMLDivElement>,
    ref: Ref<HTMLDivElement>
  ) => {
    return (
      <StyledMenuHeader
        {...props}
        className={classnames("c-menu-header", className)}
        ref={ref}
      >
        {leftElement || <div style={{ minWidth: "24px" }}>&nbsp;</div>}
        <Typography
          variant="Body 2"
          color="secondary"
          weight="bold"
          overflow="truncate"
          style={{ marginLeft: "4px", marginRight: "4px " }}
        >
          {title}
        </Typography>
        {rightElement || <div style={{ minWidth: "24px" }}>&nbsp;</div>}
      </StyledMenuHeader>
    );
  }
);

MenuHeader.displayName = "MenuHeader";
